<div>
  <input type="checkbox" class="mr-2" [id]="id" [name]="name" [(ngModel)]="value" />
  <label class="cursor-pointer select-none label" [attr.for]="id" *ngIf="label" [innerHTML]="label.label"></label>
  <evsb-error *ngIf="error" [error]="error.error" [className]="error?.className"></evsb-error>
</div>
